export default "__VITE_ASSET__33c19019__"